import angular from 'angular';
import productFinderLoanFacility from './productFinderLoanFacility';
import loanFacilityFees from './loanFacilityFees';

export default angular.module(
  'scenes.loanAppSections.scenes.loanProductFinder.scenes',
  [productFinderLoanFacility, loanFacilityFees],
).name;
